export function formatDocumentPrefix(prefix?: string | null): string {
  return prefix?.trim() ? prefix : '-';
}
